module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_0.fc995e66.png";